import React, { useRef } from 'react';

const ContactUsModal = ({ isOpen, closeModal, subject, setSubject, description, setDescription, sendEmail }) => {
  const modalRef = useRef(null);

  if (!isOpen) return null;

  // Function to handle clicks outside of the modal content
  const handleOutsideClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      closeModal();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-20"
      onClick={handleOutsideClick} // Handle outside click
    >
      <div ref={modalRef} className="bg-white rounded-lg p-6 w-96 relative">
        {/* X Button to close */}
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          onClick={closeModal}
        >
          &#x2715; {/* X symbol */}
        </button>

        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>

        {/* Subject Input */}
        <label className="block text-sm font-medium mb-1">Subject</label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          className="w-full border border-gray-300 p-2 mb-4 rounded"
          placeholder="Enter subject"
        />

        {/* Description Input */}
        <label className="block text-sm font-medium mb-1">Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full border border-gray-300 p-2 mb-4 rounded"
          placeholder="Enter description"
          rows={4}
        ></textarea>

        {/* Buttons for Send and Close */}
        <div className="flex justify-end space-x-2">
          <button
            className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded"
            onClick={sendEmail}
          >
            Send Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;
